var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 17.5,
    height: 17.5,
    fill: "#FB7C33"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.875,
    y: 1.875,
    width: 16.25,
    height: 16.25,
    fill: "#261302"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4813 11.9754L6.89616 14.2962C6.88406 14.3596 6.85986 14.375 6.78639 14.375H5.70169C5.62909 14.375 5.61699 14.3496 5.62909 14.26L7.72589 6.56311C7.7622 6.42276 7.78726 6.30142 7.79936 5.91839C7.79936 5.86768 7.82356 5.84142 7.86073 5.84142H9.4087C9.4571 5.84142 9.48216 5.8541 9.49426 5.91839L11.8469 14.2727C11.859 14.3361 11.8469 14.375 11.7855 14.375H10.5669C10.5064 14.375 10.4692 14.3596 10.4571 14.3089L9.84777 11.9754H7.4813ZM9.54094 10.7176L8.66367 7.08016L7.7985 10.7176H9.54094ZM12.8642 6.41642C12.8642 5.91839 13.1935 5.625 13.6196 5.625C14.0708 5.625 14.375 5.94465 14.375 6.41642C14.375 6.92713 14.0578 7.20784 13.6075 7.20784C13.1684 7.20784 12.8642 6.92713 12.8642 6.41642ZM12.9472 8.17584C12.9472 8.11155 12.9714 8.08619 13.0327 8.08619H14.1918C14.2531 8.08619 14.2773 8.11155 14.2773 8.17584V14.2854C14.2773 14.3496 14.2652 14.375 14.1918 14.375H13.0448C12.9714 14.375 12.9472 14.337 12.9472 14.2727V8.17584Z",
    fill: "#FB7C33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.a6bb174f8253be8184109b770b62682d.svg";
export { ForwardRef as ReactComponent };